'use strict';

var cart = require('../cart/cart');
const util = require('./util');

var updateMiniCart = true;
var scrollHeader;
const PAYPAL_BUTTON = 15;
const MOBILE_MINICART_CLASS = 'is-mobile-minicart';

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 */
function displayMessageAndRemoveFromCart(data) {
    $.spinner().stop();
    var status = data.success ? 'alert-success' : 'alert-danger';

    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append('<div class="add-to-wishlist-messages "></div>');
    }

    if ($('.move').attr('data-loggedUser') === 'true') {
        $('.add-to-wishlist-messages')
            .append('<div class="add-to-wishlist-alert text-center ' + status + '">' + data.msg + '</div>');
    } else {
        $('.add-to-wishlist-messages')
            .append('<div class="add-to-wishlist-alert text-center ' + status + '"><a href="' + data.wishlistUrl + '">' + data.notLoggedMsg + '</a></div>');
    }

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
    }, 5000);
}

/**
 * adds top distance to minicart
 */
let topDistance = function () {
    let headeHeight = $('header').height();
    let headerBannerHeight = $('.header-banner').height();
    let $miniCartPopOver = $('.minicart .popover');
    let positionTop = headerBannerHeight - $(window).scrollTop();

    if (positionTop >= 0) {
        $miniCartPopOver.css('top', positionTop + headeHeight);
        scrollHeader = headeHeight + headerBannerHeight;
    } else {
        $miniCartPopOver.css('top', headeHeight);
        scrollHeader = headeHeight;
    }
};

module.exports = function () {
    var timeOut;
    var prevFocusButton;
    cart();

    var closeObj = {
        show: false,
        timeOut: 200
    };

    $(window).on('scroll', topDistance);

    // $(window).on('scroll', function () {
    //     $('.minicart').trigger('cart:show', closeObj);
    // });

    /**
     * Closes the mobile minicart state.
     */
    function closeMobileMiniCart() {
        var $miniCartPopOver = $('.minicart .popover');
        $miniCartPopOver.removeClass(MOBILE_MINICART_CLASS);
        $miniCartPopOver.removeClass('show');
        $miniCartPopOver.removeAttr('style');
        $('body').removeClass('minicart-open');
    }

    /**
     * Moves the minicart remove confirmation modal to body on mobile so Bootstrap can manage it.
     */
    function moveMobileRemoveModalToBody() {
        if (!util.isMobile()) {
            return;
        }

        var $modalInMiniCart = $('.minicart .popover #removeProductModal');

        if (!$modalInMiniCart.length) {
            return;
        }

        $('body > #removeProductModal').remove();
        $modalInMiniCart.appendTo('body');
    }

    $('.minicart').on('cart:showMobile', function () {
        var $miniCartPopOver = $('.minicart .popover');
        var url = $('.minicart').data('action-url');
        var count = parseInt($('.minicart .minicart-quantity').text(), 10);

        if (!util.isMobile() || count === 0) {
            return;
        }

        $('body').addClass('minicart-open');
        $miniCartPopOver.addClass(MOBILE_MINICART_CLASS);
        $miniCartPopOver.css({
            height: window.innerHeight,
            top: 0
        });
        $miniCartPopOver.addClass('show');

        if (!updateMiniCart) {
            return;
        }

        $miniCartPopOver.spinner().start();
        $.get(url, function (data) {
            $miniCartPopOver.empty();
            $miniCartPopOver.append(data);
            updateMiniCart = false;
            $.spinner().stop();
            moveMobileRemoveModalToBody();

            setTimeout(function () {
                $('.minicart .product-summary').css('max-height', $('.minicart .cart').height() - ($('.minicart-header').height() + $('.minicart-footer').height() + PAYPAL_BUTTON));
                initializeFadeCheck();
            }, 300);
        });
    });

    $('.minicart').on('cart:show', function (event, obj) {
        let $miniCartPopOver = $('.minicart .popover');
        let $modalBackground = $('.modal-background');

        if (obj.show) {
            if (util.isMobile()) return;
            // hide assistance widget
            $('iframe#launcher').css({
                transition: 'none',
                opacity: '0',
                'z-index': '-1'
            });
            if (obj.button) {
                if (obj.button.hasClass('add-to-cart-global')) {
                    prevFocusButton = $('[data-quickview-uid="' + obj.button.data('pid') + '"]');
                } else {
                    prevFocusButton = obj.button;
                }

                $('.minicart a').first().focus();
            }

            var url = $('.minicart').data('action-url');
            var count = parseInt($('.minicart .minicart-quantity').text(), 10);

            if (count !== 0 && $('.minicart .popover.show').length === 0) {
                let headeHeight = $('header').height();
                let headerBannerHeight = $('.header-banner').height();

                if (scrollHeader) {
                    $miniCartPopOver.css('height', window.innerHeight - scrollHeader);
                } else if (headerBannerHeight) {
                    $miniCartPopOver.css('height', window.innerHeight - (headerBannerHeight + headeHeight));
                } else {
                    $miniCartPopOver.css('height', window.innerHeight - headeHeight);
                }

                topDistance();

                if (!updateMiniCart) {
                    $miniCartPopOver.addClass('show');
                    $modalBackground.show();
                    return;
                }

                $miniCartPopOver.addClass('show');
                $modalBackground.show();
                $miniCartPopOver.spinner().start();
                $.get(url, function (data) {
                    $miniCartPopOver.empty();
                    $miniCartPopOver.append(data);
                    updateMiniCart = false;
                    $.spinner().stop();

                    setTimeout(function () {
                        $('.minicart .product-summary').css('max-height', $('.minicart .cart').height() - ($('.minicart-header').height() + $('.minicart-footer').height() + PAYPAL_BUTTON));
                        initializeFadeCheck();
                    }, 300);
                });
            }
        } else {
            if (util.isMobile()) return;
            timeOut = setTimeout(function () {
                $modalBackground.hide();
                $miniCartPopOver.removeClass('show');
                $miniCartPopOver.css('height', '');
                if (prevFocusButton) {
                    prevFocusButton.focus();
                }

                prevFocusButton = false;
                // show assistance widget
                $('iframe#launcher').css({
                    'z-index': '999998',
                    transition: '',
                    opacity: '1'
                });
            }, obj.timeOut);
        }

        $('.remove-btn').on('click', setTimeout(function () {
            $('body > .modal-backdrop').remove();
        }, 300));
    });

    $('.minicart').on('count:update', function (event, count) {
        if (count && $.isNumeric(count.quantityTotal)) {
            $('.minicart .minicart-quantity').text(count.quantityTotal).removeClass('d-none');

            $('.minicart .minicart-link').attr({
                'aria-label': count.cart.resources.minicartCountOfItems,
                title: count.cart.resources.minicartCountOfItems
            });
        }
    });

    $('.minicart').on('mouseenter focusin', function () {
        var obj = {
            show: true
        };
        $('.minicart').trigger('cart:show', obj);
    });

    $('body').on('touchstart click', function (e) {
        if (util.isMobile()) {
            return;
        }

        if ($('.minicart').has(e.target).length <= 0) {
            $('.minicart .popover').removeClass('show');
        }
    });

    $('.minicart').on('mouseleave focusout', function (event) {
        if (event.type === 'focusout' && $(event.target).hasClass('js-view-cart-link')) {
            $('.minicart').trigger('cart:show', closeObj);
            return;
        }

        if ((event.type === 'focusout' && $('.minicart').has(event.target).length > 0) ||
            (event.type === 'mouseleave' && $(event.target).is('.minicart .quantity')) ||
            $('body').hasClass('modal-open')) {
            event.stopPropagation();
            return;
        }
        $('.minicart').trigger('cart:show', closeObj);
    });

    $('body').on('click', '.js-minicart-close', function (event) {
        event.preventDefault();
        closeMobileMiniCart();
    });

    $('body').on('focusin', '.wishlist', function () {
        if ($('.minicart .popover').length) {
            if ($('.minicart .popover').hasClass('show')) {
                $('.minicart').trigger('cart:show', closeObj);
            }
        }
    });

    $('body').on('mouseenter focusin touchstart', '.minicart .popover', function () {
        clearTimeout(timeOut);
    });

    $('body').on('product:afterAddToCart', function () {
        updateMiniCart = true;
    });
    $('body').on('cart:update', function () {
        updateMiniCart = true;
    });

    $('body').on('click', '.product-move .js-add-to-wishlist-cart', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        var pid = $(this).data('pid');
        var button = $(this);
        var optionId = $(this).closest('.product-info').find('.lineItem-options-values').data('option-id');
        var optionVal = $(this).closest('.product-info').find('.lineItem-options-values').data('value-id');
        optionId = optionId || null;
        optionVal = optionVal || null;
        if (!url || !pid) {
            return;
        }

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                pid: pid,
                optionId: optionId,
                optionVal: optionVal
            },
            success: function (data) {
                displayMessageAndRemoveFromCart(data);

                button.find('i').removeClass('icon-heart-small').addClass('icon-heart-small-hover');
                button.removeClass('js-add-to-wishlist-cart').addClass('js-remove-from-wishlist-cart');
            },
            error: function (err) {
                displayMessageAndRemoveFromCart(err);
            }
        });
    });

    $('body').on('click', '.product-move .js-remove-from-wishlist-cart', function (e) {
        e.preventDefault();
        var url = $(this).data('removeurl');
        var pid = $(this).data('pid');
        var button = $(this);

        var newUrl = util.getPathFromUrl(url);

        $.spinner().start();
        $.ajax({
            url: `${newUrl}?pid=${pid}`,
            type: 'get',
            dataType: 'json',
            data: {},
            success: function (data) {
                displayMessageAndRemoveFromCart(data);

                button.find('i').removeClass('icon-heart-small-hover').addClass('icon-heart-small');
                button.removeClass('js-remove-from-wishlist-cart').addClass('js-add-to-wishlist-cart');
            },
            error: function (err) {
                displayMessageAndRemoveFromCart(err);
            }
        });
    });

    /**
     * Initializes fade check on product summary elements.
     *
     * This function is called after the DOM is ready and after any
     * subsequent DOM mutations. It binds a scroll event handler to
     * each .product-summary element (once per element) and updates
     * the visibility of the accompanying .fade-overlay element based
     * on the element's scroll position.
     *
     * @private
     */
    function initializeFadeCheck() {
        $('.product-summary').each(function () {
            const $container = $(this);
            const $fade = $container.siblings('.fade-overlay');

            // Initial state check
            updateFade($container, $fade);

            // Scroll event (bound once per element)
            $container.off('scroll.fadeCheck').on('scroll.fadeCheck', function () {
                updateFade($(this), $(this).siblings('.fade-overlay'));
            });
        });
    }

    /**
     * Updates the visibility of a .fade-overlay based on the scroll
     * position of its accompanying .product-summary element.
     *
     * @private
     * @param {jQuery} $container - The .product-summary element
     * @param {jQuery} $fade - The .fade-overlay element
     */
    function updateFade($container, $fade) {
        const scrollTop = $container.scrollTop();
        const scrollHeight = $container.prop('scrollHeight');
        const containerHeight = $container.innerHeight();
        const atBottom = scrollTop + containerHeight >= scrollHeight - 1;

        $fade.toggleClass('hidden', atBottom);
    }

  // Observe DOM for new .product-summary elements
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(node => {
                // Check if node is or contains a .product-summary
                    if (
                        $(node).is('.product-summary') ||
                        $(node).find('.product-summary').length > 0
                    ) {
                        initializeFadeCheck();
                    }
                });
            }
        }
    });

    // Start observing <body> or the specific container if you know it
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    initializeFadeCheck();
};
